module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel8-4fb1fa5a84ab894820f0342f5a74b474.jpg";